<div class="fc-progress" aria-label="FileCapture Progress">
  @for (step of steps; track step; let i = $index) {
    <div class="fc-progress-step" [class.active]="i + 1 === currentStep" [class.complete]="i + 1 < currentStep">
      <div class="fc-progress-dot">
        @if (i + 1 < currentStep) {
          <i class="fa-solid fa-check fc-check-icon"></i>
        } @else {
          {{ i + 1 }}
        }
      </div>
      <div class="fc-progress-label">{{ step }}</div>
    </div>
  }
</div>
